/* eslint-disable */
import React, { Component } from "react";
import "./Banner.css";
import moment from "moment";
import BannerTab from "./BannerTab";
import {
  RangeDatePicker,
} from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";

import "react-day-picker/lib/style.css";

class CityStuffleBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
        startDate: null,
        endDate: null,
      isOpen: false,
      dropdownVisible: false,
      selected: "Accommodations",
      searchInput: "",
      itemsZone: [],
      error: null,
      val: "",
      value: "",
      suggestions: [],
      showResults: false,
      defaultZoneval: "Seychelles",
      addMoreLocation: [],
      checkinShow: false,
      itineraryPlan: "",
      selectedStartLocation: "",
      selectedEndLocation: "",
      UseSecondOption:false,
      cats: [
        { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
      ],
      changeDate: [
        {
          number: "",
          startDate: "",
          endDate: "",
          indexid:""
        },
      ],
      children:[
        {
          Id:"",
          Location: "",
          name: "",
          range:[ 
            { 
              number: "",
              startDate: "",
              endDate: "",
              indexid:""
            },
          ],
        }
      ],
      disableSelectOption:false,
      checkedcoming: false

    };
  }

  componentDidMount() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZoneval = urlParams.get("moreLocation");
    const checkin = urlParams.get("checkin");
    const checkout = urlParams.get("checkout");
    const guestCombination = urlParams.get("guestCombination");
    const selectedStartLocation = urlParams.get("selectedStartLocation");
    const selectedEndLocation = urlParams.get("selectedEndLocation");
 
   let querySearch = JSON.parse(guestCombination);
   this.setState({addMoreLocation:defaultZoneval});
   this.setState({ startDate: checkin });
   this.setState({ endDate: checkout });
   this.setState({ cats: querySearch });
   this.setState({ selectedStartLocation: selectedStartLocation });
   this.setState({ selectedEndLocation: selectedEndLocation });

   const numberOfLocation  = JSON.parse(defaultZoneval).length;

  let startDate = moment(checkin);
  let endDate = moment(checkout);
  let diff = endDate.diff(startDate);
  let diffDuration = moment.duration(diff);
  let TotalDays = diffDuration.days();

  let result= [];
   const startDateNew = new Date(checkin);
   const endDateNew = new Date(checkout);

  // Calculate the total number of days in the range
  const totalDays = (endDateNew - startDateNew) / (1000 * 60 * 60 * 24);
  
  // Divide the range into four equal parts
  let daysPerPart = Math.floor(totalDays / numberOfLocation);
  let reminder = totalDays % numberOfLocation;
  
  // Initialize an array to store the results
  const dividedRanges = [];
  
    JSON.parse(defaultZoneval).map((location, index) =>{
       let numberDay = '';  

      if(TotalDays%numberOfLocation ==0){
        numberDay = (TotalDays/numberOfLocation);
      }else{
        numberDay = (TotalDays%numberOfLocation);
      }
     
       let DateMain = [];
      
        const partStartDate = new Date(startDateNew);
        const partEndDate = new Date(partStartDate);
      
        // Calculate the end date for the current part
        partEndDate.setDate(partEndDate.getDate() + daysPerPart);
        // If there's a reminder, distribute it across the parts
        if (reminder > 0) {
          partEndDate.setDate(partEndDate.getDate()+1);
          reminder--;
        }

        // Store the calculated part in the results array
        let startDateNewData = moment(partStartDate);
        let endDateNewData = moment(partEndDate);
 
  let diffNewDataNew = endDateNewData.diff(startDateNewData, 'days');

        DateMain.push({
          number: diffNewDataNew,
          startDate: moment(partStartDate).format("Y-MM-DD"),
          endDate:  moment(partEndDate).format("Y-MM-DD"),
          indexid:index
        });
      ;
        dividedRanges.push({
          number: diffNewDataNew,
          startDate: moment(partStartDate).format("Y-MM-DD"),
          endDate: moment(partEndDate).format("Y-MM-DD"),
          indexid:index
        });
        // Update the start date for the next part
        startDateNew.setDate(partEndDate.getDate());
    
   
      let newData =  {
        Id:location.id,
        Location: location.value,
        name: diffNewDataNew,
        range: DateMain,
      }
      result.push(newData);
    })
   
    this.setState({changeDate:dividedRanges});
    this.setState({children:result});
    const treeData = [
      {
        cat: querySearch,
        Planname: `${JSON.parse(defaultZoneval).map((list) => JSON.stringify(list?.value?.label)).join(", ")} - (${moment(checkin).format("ddd, DD MMM Y")} - ${moment(checkout).format("ddd, DD MMM Y")})`,
        range: [{startDate:checkin, endDate:checkout}],
        numberOfDay: TotalDays,
        numberOfLocation: numberOfLocation,
        children: result,
      },
    ];

  this.setState({ itineraryPlan: treeData });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.globalClickListener);
  }
  globalClickListener = (nativeEvent) => {

    this.setState(
      { dropdownVisible: false, showResults: false, checkinShow: false },
      () => {
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };
  handleDateChange = (startDate, endDate, index) => {

let updatedData = [];
let updatedDataNew = [];
let valueData = [];
//for (let i = 0; i < this.state.changeDate.length; i++) {
  JSON.parse(this.state.addMoreLocation).map((location, i) =>{

  // Create a copy of the original array
 let DateMain = [];
 
      const indexToUpdate = this.state.changeDate.find(item => item.indexid === i);
 
    //  if(newStartDateNewData >=newStartDateNews){
  if(i == index){
    const newStartDate= new Date(startDate);
   
     const newEndDate=new Date(endDate);
     let result=moment(newEndDate).diff(newStartDate,'days');

     if(i == this.state.changeDate.length-1){
      this.setState({ endDate: endDate });
     }
 
   DateMain.push({
    number: result,
    startDate: moment(startDate).format("Y-MM-DD"),
    endDate:  moment(endDate).format("Y-MM-DD"),
    indexid:i
  });
   let newData =  {
    Id:location.id,
    Location: location.value,
    name: result,
    range: DateMain,
  }
  updatedDataNew.push(newData);

  this.setState((prevState) => {
    updatedData = [...prevState.changeDate]; // Create a copy of the original array
     updatedData[i].startDate = startDate; // Update the value at the specified index
     updatedData[i].endDate = endDate; // Update the value at the specified index
     updatedData[i].number = result; // Update the value at the specified index

    // valueData = { changeDate: updatedData };
    
     return { changeDate: updatedData }; // Update the state with the modified array
    
     
   });
// }else{
//   alert(
//     'Your Start Date is not equal to or greater then'
//   );
//   return false;
// }
     


  }else if(i==index+1){

   // const indexToUpdate = this.state.changeDate.find(item => item.indexid === i);
    const indexToUpdatenext = this.state.changeDate.find(item => item.indexid === i);
    
   let endDateNew = moment(indexToUpdatenext.startDate).add(indexToUpdatenext?.number, 'day').format("Y-MM-DD");
    
    const newStartDate= new Date(endDate);
    const newEndDate=new Date(indexToUpdatenext.endDate);
   
    let result=moment(newEndDate).diff(newStartDate,'days');
   
    DateMain.push({
      number: result,
      startDate: moment(endDate).format("Y-MM-DD"),
      endDate:  moment(endDateNew).format("Y-MM-DD"),
      indexid:i
    });
     let newData =  {
      Id:location.id,
      Location: location.value,
      name: result,
      range: DateMain,
    }
    updatedDataNew.push(newData);

    this.setState((prevState) => {
      updatedData = [...prevState.changeDate]; // Create a copy of the original array
      updatedData[i].startDate = endDate; // Update the value at the specified index
      updatedData[i].endDate = endDateNew; // Update the value at the specified index
      updatedData[i].number = result; // Update the value at the specified index
    
      return { changeDate: updatedData }; // Update the state with the modified array
      //valueData = { changeDate: updatedData };
    });
  }
  // else if(i >= this.state.changeDate.length-2){
  //   const indexToUpdatedata = this.state.changeDate.find(item => item.indexid === i-1);
  
  // let endDateNew = moment(indexToUpdate.endDate).format("Y-MM-DD");
    
  //  const newStartDate= new Date(indexToUpdatedata.endDate);
  //  const newEndDate=new Date(indexToUpdate.endDate);
  
  //  let result=moment(newEndDate).diff(newStartDate,'days');
  
  
  //  DateMain.push({
  //   number: result,
  //   startDate: moment(newStartDate).format("Y-MM-DD"),
  //   endDate:  moment(endDateNew).format("Y-MM-DD"),
  //   indexid:i
  // });
  //  let newData =  {
  //   Id:location.id,
  //   Location: location.value,
  //   name: result,
  //   range: DateMain,
  // }
  // updatedDataNew.push(newData);
  // this.setState((prevState) => {
  //   updatedData = [...prevState.changeDate]; // Create a copy of the original array
  //   updatedData[i].startDate = newStartDate; // Update the value at the specified index
  //   updatedData[i].endDate = endDateNew; // Update the value at the specified index
  //   updatedData[i].number = result; // Update the value at the specified index
  
  
  //   return { changeDate: updatedData }; // Update the state with the modified array
  //  //valueData = { changeDate: updatedData };
  // });
  // }
   else if(i == this.state.changeDate.length-1){
    const indexToUpdatedata = this.state.changeDate.find(item => item.indexid === i-1);
   
   let endDateNew = moment(indexToUpdatedata.endDate).format("Y-MM-DD");
    
   const newStartDate= new Date(indexToUpdatedata.endDate);
   const newEndDate=new Date(this.state.endDate);
  
   let result=moment(newEndDate).diff(newStartDate,'days');
 
 
   DateMain.push({
    number: result,
    startDate: moment(endDateNew).format("Y-MM-DD"),
    endDate:  moment(this.state.endDate).format("Y-MM-DD"),
    indexid:i
  });
   let newData =  {
    Id:location.id,
    Location: location.value,
    name: result,
    range: DateMain,
  }
  updatedDataNew.push(newData);

  this.setState((prevState) => {
    updatedData = [...prevState.changeDate]; // Create a copy of the original array
    updatedData[i].startDate = endDateNew; // Update the value at the specified index
    updatedData[i].endDate = this.state.endDate; // Update the value at the specified index
    updatedData[i].number = result; // Update the value at the specified index
   
    return { changeDate: updatedData }; // Update the state with the modified array
   // valueData = { changeDate: updatedData };
  });
  }else{

    const indexToUpdatedata = this.state.changeDate.find(item => item.indexid === i);
 
    let endDateNew = moment(indexToUpdatedata?.endDate).format("Y-MM-DD");
    let startDateNew = moment(indexToUpdatedata?.startDate).format("Y-MM-DD");
     
    const newStartDate= new Date(indexToUpdatedata?.startDate);
    const newEndDate=new Date(indexToUpdatedata?.endDate);
   
    let result=moment(newEndDate).diff(newStartDate,'days');
  
  
    DateMain.push({
     number: result,
     startDate: startDateNew,
     endDate: endDateNew,
     indexid:i
   });
    let newData =  {
     Id:location.id,
     Location: location.value,
     name: result,
     range: DateMain,
   }
   updatedDataNew.push(newData);
 
   this.setState((prevState) => {
     updatedData = [...prevState.changeDate]; // Create a copy of the original array
     updatedData[i].startDate = startDateNew; // Update the value at the specified index
     updatedData[i].endDate = endDateNew; // Update the value at the specified index
     updatedData[i].number = result; // Update the value at the specified index
    
     return { changeDate: updatedData }; // Update the state with the modified array
    // valueData = { changeDate: updatedData };
   });
  }
  // dataArray[i].startDate = newStartDate;
  // dataArray[i].endDate = newEndDate;
// }else{
//     alert(
//       'Your Start Date is not equal to or greater then'
//     );
//  
//     return false;
//   }


})
this.setState({children:updatedDataNew});
const treeData = [
  {
    cat: this.state.itineraryPlan[0].cat,
    Planname: this.state.itineraryPlan[0].Planname,
    range: [{startDate:this.state.startDate, endDate:this.state.endDate}],
    numberOfDay: this.state.itineraryPlan[0].numberOfDay,
    numberOfLocation: this.state.changeDate.length,
    children: updatedDataNew,
  },
];

this.setState({ itineraryPlan: treeData });

return  valueData; 
  }
  
  handleSelectStartChange = (event) => {
    this.setState({ selectedStartLocation: event.target.value });
    this.setState({ selectedEndLocation: "" });
    this.setState({ disableSelectOption: false });
    this.setState({ checkedcoming: false });

  };
  handleSelectEndChange = (event) => {
    this.setState({ selectedEndLocation: event.target.value });
  };
  handleCheckboxChange = (e) => {
    if (e.target.checked) {
      this.setState({ selectedEndLocation: this.state.selectedStartLocation });
      this.setState({ disableSelectOption: true });
      this.setState({ checkedcoming: true });
      
    }else{
      this.setState({ selectedEndLocation: "" });
      this.setState({ disableSelectOption: false });
      this.setState({ checkedcoming: false });
    }
  };

  render() {
  
    return (
      <>
        <BannerTab isSelected={this.props.isSelected === "Accommodations"}>
          <div className="title-trip-plan" title="">
            {" "}
            Select duration for Islands / Cities
          </div>
          <p className="title-trip-para" style={{ margin: 0 }}>
            Edit your islands/cities to change your route
          </p>
          <p className="title-trip-para">
            Start Date <span className="cityStufDate">{moment(this.state.startDate).format("ddd, DD MMM Y")}</span> - End
            Date <span className="cityStufDate">{moment(this.state.endDate).format("ddd, DD MMM Y")}</span>
          </p>
          
          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 Allhover">
            <div className="routes" style={{ marginBottom: "10px", marginBottom: "1%", padding: "10px", justifyContent: "center", marginLeft: "20%", width: "60%",}} >
              <div>
                <h4 style={{margin: '5px 0px'}}><b>Kindly let us know your arrival point in seychelles?</b></h4>
                <p style={{margin: '5px 0px', fontStyle: 'italic'}}>(The arrival point to the Seychelles from anywhere will either be the “International Airport” which is located in Mahe Island OR the “Sea ports” located in Praslin or La Digue Island.)</p></div>
                    <select id="mySelect" value={this.state.selectedStartLocation} onChange={this.handleSelectStartChange}>
                      <option value="">-- Select Location --</option>
                      <option value="Mahe Island">Mahe Island</option>
                      <option value="Praslin Island">Praslin Island</option>
                      <option value="La Digue Island">La Digue Island</option>
                    </select>
                    {this.state.selectedStartLocation !='' &&(
                    <div style={{ marginBottom: "10px", marginTop: "10px"}}>
                  <input
                      type="checkbox"
                      id="useSecondOption" checked={this.state.checkedcoming}
                      onChange={this.handleCheckboxChange}
                    />
                    <label htmlFor="useSecondOption" style={{marginLeft: '5px'}}> I'm coming back to this location</label>  
                    </div>)}
                    
                    </div>
              </div>
          
         {this.state.itineraryPlan[0]?.children.length>0 &&(this.state.itineraryPlan[0]?.children.map((location, indexva) => (
           <div key={location?.Id}
                className="serch-top-bar"
                style={{
                  marginBottom: "1%",
                  padding: "0px 5px 0px",
                  justifyContent: "center",
                  marginLeft: "20%",
                  width: "60%",
                }}
              >
                <div className="row" style={{ lineHeight: 1 }}>
                  <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 Allhover">
                    <div className="routes">
                      <div className="round">
                        <span>
                          <i className="fa fa-map-marker" aria-hidden="true" style={{color: '#ff924b'}}></i>{" "}
                          {location?.Location?.label}
                        </span>
                        <div
                          className="dropdown-toggle"
                          data-toggle="dropdown"
                          style={{ float: "right" }}
                        >
                          <p
                            style={{
                              fontSize: "20px !important",
                              color: "#eea027 !important",
                              marginTop: "13px !important",
                              position: "relative",
                            }}
                          >
                            {this.state.changeDate[indexva].number} Night
                            {/* <i
                              className="fa fa-pencil"
                              aria-hidden="true"
                              style={{ marginLeft: "10px" }}
                            ></i> */}
                          </p>
                        </div>
                        <div className="checkboxs">
                          <p
                            style={{
                              fontSize: "14px",
                              margin: "10px 5px 5px 12px",
                              padding: "5px 5px 7px",
                              textAlign: "left",
                            }}
                          >
                          {moment(this.state.changeDate[indexva].startDate).format("ddd, DD MMM Y")} - {moment(this.state.changeDate[indexva].endDate).format("ddd, DD MMM Y")}
                          </p>
                        </div>
                        <div className="dropdown-menus">
                          <div className="Most Popular">
                            <div className="form-row">
                             
                              <div className="form-group col-md-12">
                               
                                <div className="bor" style={{ marginBottom: '10px', height: '45px'}}>
                                   
                                    <RangeDatePicker
                                        startDate={this.state.changeDate[indexva].startDate}
                                        endDate={this.state.changeDate[indexva].endDate}
                                        onChange={(startDate, endDate ) =>this.handleDateChange(startDate, endDate, indexva)} 
                                        minDate={new Date(this.state.startDate)}
                                        maxDate={new Date(this.state.endDate)}
                                        startDatePlaceholder="Check In"
                                        endDatePlaceholder="Check Out"
                                        className="my-own-class-name"
                                        startWeekDay="monday"
                                    />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)
                ))}
      
              <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 Allhover">
            <div className="routes" style={{ marginBottom: "10px", marginBottom: "1%", padding: "10px", justifyContent: "center", marginLeft: "20%", width: "60%",}} >
              <div>
                <h4 style={{margin: '5px 0px'}}><b>Kindly let us know your departure point from seychelles?</b></h4>
                <p style={{margin: '5px 0px', fontStyle: 'italic'}}>(The departure point from Seychelles to anywhere will either be the “International Airport” which is located in Mahe Island OR the “Sea ports” located in Praslin or La Digue Island.)</p></div>
                <select id="mySelect" value={this.state.selectedEndLocation} onChange={this.handleSelectEndChange} disabled={this.state.disableSelectOption}>
                      <option value="">-- Select Location --</option>
                      <option value="Mahe Island">Mahe Island</option>
                      <option value="Praslin Island">Praslin Island</option>
                      <option value="La Digue Island">La Digue Island</option>
                    </select>
                    </div>
              </div>

          <div className="right-sidebar">
            <a href={"/itineraryDetails?moreLocation=" + encodeURIComponent(JSON.stringify(this.state.addMoreLocation)) + "&checkin=" + encodeURIComponent(this.state.startDate) + "&checkout=" + encodeURIComponent(this.state.endDate) + "&guestCombination=" + JSON.stringify(this.state.cats) + "&itineraryPlan=" + encodeURIComponent(JSON.stringify(this.state.itineraryPlan)) + "&changeDate=" + encodeURIComponent(JSON.stringify(this.state.changeDate))+
                "&selectedStartLocation=" +
                encodeURIComponent(this.state.selectedStartLocation) +
                "&selectedEndLocation=" +
                encodeURIComponent(this.state.selectedEndLocation) }>
              <h4>
                Move to <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </h4>
              <p> Itinerary</p>
            </a>
          </div>

          <div className="left-sidebar">
            <a  href={"/makebuildtrip?moreLocation=" + encodeURIComponent(this.state.addMoreLocation) + "&checkin=" + encodeURIComponent(this.state.startDate) + "&checkout=" + encodeURIComponent(this.state.endDate) + "&guestCombination=" + JSON.stringify(this.state.cats) + "&itineraryPlan=" + encodeURIComponent(JSON.stringify(this.state.itineraryPlan)) + "&changeDate=" + encodeURIComponent(JSON.stringify(this.state.changeDate))+
                "&selectedStartLocation=" +
                encodeURIComponent(this.state.selectedStartLocation) +
                "&selectedEndLocation=" +
                encodeURIComponent(this.state.selectedEndLocation) }>
              <h4>
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
              </h4>
              <p>Make Trip</p>
            </a>
          </div>
        </BannerTab>
      </>
    );
  }
}
export default CityStuffleBanner;
